$(->
  # TODO: (8/4/17, charis@careerplug.com) I strongly suspect that this is stale code. I see it being used potentially in two places:
  #
  # 1. app/views/manage/accounts/_account_description_fields.html.erb
  #     - This partial seems to involve editing a company description for a state farm agent, using a
  #       builder-type UI. However, the UI appears to be weird and broken.
  # 2. app/views/manage/jobs/_job_builder_fields.html.erb
  #     - I believe this is involved with editing a state farm job, again with a job builder. However,
  #       that functionality continues to work with this removed, so I think that is being accomplished somewhere else.
  $('.sub-question-holder input').change(->
    if $(this).closest('.sub-question-wrapper').length > 0
      return
    if $(this).prop('checked')
      $(this).closest('.sub-question-holder').find('.sub-question-wrapper').slideDown('fast')
    else
      $(this).closest('.sub-question-holder').find('.sub-question-wrapper').slideUp('fast')
  ).change()

)
